function* manifestsGenerator(manifests = []) {
    const clone = manifests.slice(0);
    yield* clone;
}

export default manifestsGenerator;
